import { render, staticRenderFns } from "./CardEventRequest.vue?vue&type=template&id=40403377&scoped=true"
import script from "./CardEventRequest.vue?vue&type=script&lang=js"
export * from "./CardEventRequest.vue?vue&type=script&lang=js"
import style0 from "./CardEventRequest.vue?vue&type=style&index=0&id=40403377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40403377",
  null
  
)

export default component.exports